import localStorageCall from '@/services/Methods/localstorage.hook';
import * as Yup from 'yup';
import moment from 'moment';

const CheckoutValidationSchema = (loginUser = false, condition = { autoship: false, age: false, distributorSignup: false, singleMemberShip: false, webAlias: false, webAliase: false, taxType: false, taxId: false, gNumber: false, gNumberTerms: false, ambtermscondition: false, jpStudentTerms: false, jpAgeTerms: false, jpCitizen: false, country: 'US', isDob: false, isAmbassador: false }) => {

    
    const Schema = Yup.object().shape({
        shipping_urname: Yup.string().trim().required('Enter your firstname'),
        webAlias: condition?.webAlias ? Yup.string().trim().required('Enter your Webalias Code').matches(/^[a-zA-Z0-9_]*$/, "Space not allowed in WebAlias ") : Yup.string().notRequired(),
        webAliase: condition?.webAliase && loginUser == null ? Yup.string().trim().required('Select Enroller') : Yup.string().notRequired(),
        shipping_lastname: Yup.string().trim().required('Enter your lastname'),
        gNumber: condition?.gNumber ? Yup.string().trim().required('Gaiyoshomen Number is required') : Yup.string().notRequired(),
        shipping_email: Yup.string().trim().required('Enter your email').email('Enter valid email')
            .matches(/^(?!.*\.{2,})(?=.*@)[^@]+(?=.*\.[^.]+$).*/, 'Invalid email address'),
        password: (loginUser == null)
            ?
            Yup.string().required("Password is required").matches(/^(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*()_\-+=<>?:"{}|~`'[\]\\;,.\/]{6,}$/, 'Password must contain an uppercase, a number and minimum of six characters')
            // /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{6,}$/
            :
            Yup.string().notRequired(),
        confirm_password: (loginUser == null)
            ?
            Yup.string().required("Confirm password is required").test('confirm_password', 'Password and confirm password should be same', function (val) {
                const password = this.resolve(Yup.ref('password'));
                if (val !== password) return false;
                return true;
            })
            : Yup.string().notRequired(),
        shipping_street: Yup.string().required('Street address is required.'),
        shipping_street2: Yup.string().notRequired(),
        shipping_city: Yup.string().required('City is required.'),
        shipping_zipcode: Yup.string().required('Zipcode is required.'),
        shipping_country: Yup.string().required('Please select your country.'),
        shipping_state: Yup.string().required('Please select your state.'),
        shipping_phone: Yup.string()
            .required('Enter your phone number').min(7, "Invalid phone number").max(20, "Invalid phone number").matches(/^\d+$/, "Only numbers without spaces are allowed."),
        termscondition: condition?.distributorSignup ? Yup.bool().notRequired() : Yup.bool().oneOf([true], 'Please accept the terms and conditions'),
        ambtermscondition: condition?.ambtermscondition ? Yup.bool().oneOf([true], 'Please accept the terms and conditions') : Yup.bool().notRequired(),
        ageCheck: condition?.age ? Yup.bool().oneOf([true], 'Please accept that you are 18 years old or over') : Yup.bool().notRequired(),
        policyProcedures: condition?.distributorSignup ? Yup.bool().notRequired() : Yup.bool().oneOf([true], 'Please accept the Policies & Procedures'),
        taxType: condition?.taxType ? Yup.string().required('Please select your Tax Type') : Yup.string().notRequired(),
        taxId: condition?.taxId ? Yup.string().trim().required('Please enter your Tax ID') : Yup.string().notRequired(),
        gNumberTerms: condition?.gNumberTerms ? Yup.bool().oneOf([true], 'Please acknowledge and agree to the following statements.') : Yup.bool().notRequired(),
        jpStudentTerms: condition?.jpStudentTerms ? Yup.bool().oneOf([true], 'Please acknowledge and agree to the following statements.') : Yup.bool().notRequired(),
        // jpAgeTerms: condition?.jpAgeTerms ? Yup.bool().oneOf([true], 'Please acknowledge and agree to the following statements.') : Yup.bool().notRequired(),
        jpCitizen: condition?.jpCitizen ? Yup.string().required('Please select Yes or No') : Yup.string().notRequired(),
        dob: condition?.isDob ? Yup.date().required('Date of Birth is required').test(
            'age-check',
            'You must be 20 years or older to enroll as an Ambassador with Viago Direct.',
            function (value) {
                if (condition?.country === 'JP' && condition?.isAmbassador && value) {
                    const dob = moment(value);
                    const today = moment();
                    const age = today.diff(dob, 'years');
                    return age >= 20;
                }
                return true;
            }
        ) : Yup.date().notRequired(),
    });

    return Schema;
};


export default CheckoutValidationSchema;